// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b07ad8fb","590":"05a073ae"}[chunkId] + ".chunk.js";
};